// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tep-officials-wrap[data-v-6c6336a6] {\r\n    display: flex;\r\n    align-items: center;\r\n    width: -moz-max-content;\r\n    width: max-content;\r\n    padding-top: 10px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
